import { Offer } from "@/services/backend/qpm/offers/types/offer";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import t from "@/lang/lang";
import {
  FloatNumberInput,
  IntNumberInput,
} from "@/shared/components/domain/qpm/inputs/number-input";
import {
  resolvedPriceAvailability,
  resolvedPriceVisibility,
} from "@/routes/processes/[processId]/qpm/offers/[offerId]/_components/price-visibility";
import { InfoIconTooltip } from "@/shared/components/domain/qpm/info-icon-tooltip";

export type RentingTableComponentProps = {
  offer: Offer;
};

export function RentingTableComponent({ offer }: RentingTableComponentProps) {
  const disabled = offer.immutable;
  const visibility = resolvedPriceVisibility(offer);
  const availability = resolvedPriceAvailability(offer);
  return (
    <Table className="min-w-[760px]">
      <TableHeader>
        <TableRow className="bg-muted/30">
          <TableHead className="h-10 px-2 py-2 font-semibold">
            {t("Position")}
          </TableHead>
          <TableHead className="h-10 px-2 py-2 text-end font-semibold">
            {t("Dauer")}
          </TableHead>
          <TableHead className="h-10 px-2 py-2 text-end font-semibold">
            {t("Monatsrate ohne Funktionsprüfung")}
          </TableHead>
          <TableHead className="h-10 px-2 py-2 text-end font-semibold">
            {t("Monatsrate inklusive Funktionsprüfung")}
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {availability.renting.aLoRa && (
          <TableRow
            className={
              visibility.renting.aLoRa
                ? "border-none"
                : "border-none opacity-50"
            }
          >
            <TableCell className="px-2 py-2.5 text-sm font-medium sm:text-base">
              <div className="flex items-center gap-2">
                <span>{t("Mietpreis ALoRa")}</span>
                {!visibility.renting.aLoRa ? (
                  <InfoIconTooltip
                    text={t(
                      "Diese Position ist im PDF ausgeblendet, da sie in den Preispositionen deaktiviert wurde.",
                    )}
                  />
                ) : null}
              </div>
            </TableCell>
            <TableCell className="px-2 py-2.5 text-end">
              <IntNumberInput
                className="ml-auto w-20"
                value={offer.rentingResult.rentingDuration}
                disabled={disabled || !visibility.renting.aLoRa}
              />
            </TableCell>
            <TableCell className="px-2 py-2.5 text-end">
              <FloatNumberInput
                className="ml-auto w-32"
                value={offer.rentingResult.rentPerMonth}
                disabled={disabled || !visibility.renting.aLoRa}
              />
            </TableCell>
            <TableCell className="px-2 py-2.5 text-end">
              <FloatNumberInput
                className="ml-auto w-32"
                value={offer.rentingResult.rentPerMonthWithMaintenance}
                disabled={disabled || !visibility.renting.aLoRa}
              />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
